export const iconFontAwesomeMapsLandmark = (
	<i className="fa-solid fa-landmark"></i>
);
